PJQ.views.modals = {};

PJQ.views.modals.YesNo = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			okButtonText: "Yes",
			onOk: _.bind(function () {
				if (_.size(this.options.cookie) > 0) {
					PJQ.helpers.cookieHelpers.setCookie(this.options.cookie, true);
				}

				if (typeof this.options.onYes === 'function') {
					this.options.onYes();
				}
			}, this),
			isShowSecondaryButton: true,
			secondaryButtonText: "No",
			onSecondary: _.bind(function () {
				if (typeof this.options.onNo === 'function') {
					this.options.onNo();
				}
			}, this)
		}, this.options);
	}
});

PJQ.views.modals.SaveDontSave = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			okButtonText: "Save",
			onOk: _.bind(function () {
				if (typeof this.options.onSave === 'function') {
					this.options.onSave();
				}
			}, this),
			isShowSecondaryButton: !(this.options.isShowDontSaveButton === false),
			secondaryButtonText: "Don't Save",
			onSecondary: _.bind(function () {
				if (typeof this.options.onDontSave === 'function') {
					this.options.onDontSave();
				}
			}, this),
			isShowCancelButton: true,
			cancelButtonColorClass: this.options.declineButtonColorClass ? this.options.declineButtonColorClass : "secondary",
			cancelButtonText: "Cancel",
			onClose: _.bind(function () {
				if (typeof this.options.onCancel === 'function') {
					this.options.onCancel();
				}
			}, this)
		}, this.options);
	}
});

PJQ.views.modals.DeleteCancel = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			okButtonText: this.options.deleteButtonText ? this.options.deleteButtonText : "Delete",
			okButtonColorClass: this.options.deleteButtonColorClass ? this.options.deleteButtonColorClass : 'danger',
			onOk: _.bind(function () {
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete();
				}
			}, this),
			isShowCancelButton: true,
			cancelButtonColorClass: this.options.declineButtonColorClass ? this.options.declineButtonColorClass : "secondary",
			cancelButtonText: this.options.declineButtonText ? this.options.declineButtonText : "Cancel",
			onClose: _.bind(function () {
				if (typeof this.options.onCancel === 'function') {
					this.options.onCancel();
				}
			}, this)
		}, this.options);
	}
});

PJQ.views.modals.CopyDelete = PJQ.views.BaseModal.extend({
	beforeModalCreated: function () {
		this.options = _.defaults({
			isShowOkButton: true,
			secondaryButtonColorClass: 'danger',
			okButtonText: "Copy All User Types",
			onOk: _.bind(function () {
				if (typeof this.options.onYes === 'function') {
					this.options.onYes();
				}
			}, this),
			isShowSecondaryButton: true,
			secondaryButtonText: "Delete All User Types",
			onSecondary: _.bind(function () {
				if (typeof this.options.onNo === 'function') {
					this.options.onNo();
				}
			}, this)
		}, this.options);
	}
});

//This modal is used for pages where there should be no other action behind the modal (at least without further action)
//The template provides no way for the user to close the dialog
PJQ.views.modals.ErrorModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Modal-Error')
	}
});
